(() => {
  /* =======================================================
     INIT
     ======================================================= */

  function initializeRecommendations(
    root = document
  ) {
    const sections =
      root.querySelectorAll?.(
        '[data-bivalta-product-recommendations]'
      ) || [];


    sections.forEach(
      initializeSection
    );
  }


  function initializeSection(
    section
  ) {
    if (
      section.dataset
        .bivaltaRecommendationsInitialized ===
      'true'
    ) {
      return;
    }


    section.dataset
      .bivaltaRecommendationsInitialized =
      'true';


    const url =
      section.dataset.url;


    /*
     * First page render does not contain
     * recommendations yet.
     */

    const track =
      section.querySelector(
        '[data-bivalta-recommendations-track]'
      );


    if (!track) {

      if (url) {
        loadRecommendations(
          section,
          url
        );
      }


      return;
    }


    initializeCarousel(
      section
    );
  }


  /* =======================================================
     FETCH SHOPIFY RECOMMENDATIONS
     ======================================================= */

  async function loadRecommendations(
    section,
    url
  ) {
    try {

      const requestUrl =
        new URL(
          url,
          window.location.origin
        );


      const response =
        await fetch(
          requestUrl.toString(),
          {
            method:
              'GET',

            headers: {
              Accept:
                'text/html'
            },

            cache:
              'no-store'
          }
        );


      if (!response.ok) {
        throw new Error(
          `Recommendations HTTP ${response.status}`
        );
      }


      const html =
        await response.text();


      const parser =
        new DOMParser();


      const documentResponse =
        parser.parseFromString(
          html,
          'text/html'
        );


      const replacement =
        documentResponse.querySelector(
          '[data-bivalta-product-recommendations]'
        );


      if (
        !replacement ||
        !replacement.innerHTML.trim()
      ) {
        section.remove();

        return;
      }


      section.innerHTML =
        replacement.innerHTML;


      section.dataset
        .bivaltaRecommendationsInitialized =
        'true';


      initializeCarousel(
        section
      );


      /*
       * Product Cards were dynamically inserted.
       * Re-initialize any global product-card system
       * by dispatching an event.
       */

      document.dispatchEvent(
        new CustomEvent(
          'bivalta:recommendations-loaded',
          {
            detail: {
              section
            }
          }
        )
      );


    } catch (error) {

      console.error(
        'Bivalta recommendations:',
        error
      );


      section.remove();

    }
  }


  /* =======================================================
     CAROUSEL
     ======================================================= */

  function initializeCarousel(
    section
  ) {
    const track =
      section.querySelector(
        '[data-bivalta-recommendations-track]'
      );


    if (!track) {
      return;
    }


    const slides =
      Array.from(
        track.querySelectorAll(
          '.bivalta-product-recommendations__slide'
        )
      );


    if (
      slides.length === 0
    ) {
      section.remove();

      return;
    }


    const prev =
      section.querySelector(
        '[data-bivalta-recommendations-prev]'
      );


    const next =
      section.querySelector(
        '[data-bivalta-recommendations-next]'
      );


    const dotsContainer =
      section.querySelector(
        '[data-bivalta-recommendations-dots]'
      );


    buildDots(
      track,
      slides,
      dotsContainer
    );


    prev?.addEventListener(
      'click',
      () => {
        scrollCarousel(
          track,
          -1
        );
      }
    );


    next?.addEventListener(
      'click',
      () => {
        scrollCarousel(
          track,
          1
        );
      }
    );


    let ticking =
      false;


    track.addEventListener(
      'scroll',
      () => {

        if (ticking) {
          return;
        }


        ticking =
          true;


        window.requestAnimationFrame(
          () => {

            updateControls(
              track,
              prev,
              next
            );


            updateDots(
              track,
              slides,
              dotsContainer
            );


            ticking =
              false;

          }
        );

      },
      {
        passive:
          true
      }
    );


    window.addEventListener(
      'resize',
      () => {

        updateControls(
          track,
          prev,
          next
        );


        updateDots(
          track,
          slides,
          dotsContainer
        );

      },
      {
        passive:
          true
      }
    );


    updateControls(
      track,
      prev,
      next
    );


    updateDots(
      track,
      slides,
      dotsContainer
    );
  }


  /* =======================================================
     SCROLL
     ======================================================= */

  function scrollCarousel(
    track,
    direction
  ) {
    const slide =
      track.querySelector(
        '.bivalta-product-recommendations__slide'
      );


    if (!slide) {
      return;
    }


    const styles =
      window.getComputedStyle(
        track
      );


    const gap =
      Number.parseFloat(
        styles.columnGap ||
        styles.gap ||
        0
      );


    const amount =
      slide.getBoundingClientRect()
        .width +
      gap;


    track.scrollBy({
      left:
        amount *
        direction,

      behavior:
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
          ? 'auto'
          : 'smooth'
    });
  }


  /* =======================================================
     BUTTON STATES
     ======================================================= */

  function updateControls(
    track,
    prev,
    next
  ) {
    const tolerance =
      3;


    const start =
      track.scrollLeft <=
      tolerance;


    const end =
      track.scrollLeft +
        track.clientWidth >=
      track.scrollWidth -
        tolerance;


    if (prev) {
      prev.disabled =
        start;
    }


    if (next) {
      next.disabled =
        end;
    }
  }


  /* =======================================================
     DOTS
     ======================================================= */

  function buildDots(
    track,
    slides,
    container
  ) {
    if (!container) {
      return;
    }


    container.innerHTML =
      '';


    slides.forEach(
      (_, index) => {

        const dot =
          document.createElement(
            'span'
          );


        dot.className =
          'bivalta-product-recommendations__dot';


        if (
          index === 0
        ) {
          dot.classList.add(
            'is-active'
          );
        }


        container.appendChild(
          dot
        );

      }
    );
  }


  function updateDots(
    track,
    slides,
    container
  ) {
    if (
      !container ||
      slides.length === 0
    ) {
      return;
    }


    const dots =
      Array.from(
        container.children
      );


    const trackRect =
      track.getBoundingClientRect();


    let closestIndex =
      0;


    let closestDistance =
      Number.POSITIVE_INFINITY;


    slides.forEach(
      (slide, index) => {

        const rect =
          slide.getBoundingClientRect();


        const distance =
          Math.abs(
            rect.left -
            trackRect.left
          );


        if (
          distance <
          closestDistance
        ) {
          closestDistance =
            distance;


          closestIndex =
            index;
        }

      }
    );


    dots.forEach(
      (dot, index) => {

        dot.classList.toggle(
          'is-active',
          index ===
            closestIndex
        );

      }
    );
  }


  /* =======================================================
     INITIAL LOAD
     ======================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initializeRecommendations();
      }
    );

  } else {

    initializeRecommendations();

  }


  /* =======================================================
     SHOPIFY EDITOR
     ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initializeRecommendations(
        event.target
      );

    }
  );

})();